
import { NewReleases } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import Badge from "@mui/material/Badge";
import { Link } from "react-router-dom";
import { StyledMenuSubItem } from '../../styled/Layout';

const ListSubItemComponent = ({
  path,
  selected,
  title,
  title2,
  icon: Icon,
  open,
  id,
  isNew,
  notification,
  tooltipText,
}) => {
  return (
    <StyledMenuSubItem.List open={open} component="div" disablePadding>
      {!open ? (
        <Tooltip title={tooltipText} placement="bottom" arrow>
          <StyledMenuSubItem.Nested
            component={Link}
            itemSelected={selected}
            to={path}
            id={id}
          >
            <StyledMenuSubItem.ListIcon>{Icon}</StyledMenuSubItem.ListIcon>
            {open && (
              <div sx={{ lineHeight: 1.3 }}>
                <StyledMenuSubItem.Text >{title}</StyledMenuSubItem.Text>
                <StyledMenuSubItem.Text >{title2}</StyledMenuSubItem.Text>
              </div>
            )}
            {isNew && (
              <StyledMenuSubItem.RightIcon>
                <NewReleases />
              </StyledMenuSubItem.RightIcon>
            )}
            {notification > 0 && (
              <StyledMenuSubItem.RightIcon>
                <Badge badgeContent={notification} color="primary" />
              </StyledMenuSubItem.RightIcon>
            )}
          </StyledMenuSubItem.Nested>
        </Tooltip>
      ) : (
        <StyledMenuSubItem.Nested
          component={Link}
          itemSelected={selected}
          to={path}
          id={id}
        >
          <StyledMenuSubItem.ListIcon>{Icon}</StyledMenuSubItem.ListIcon>
          {open && (
            <div style={{ lineHeight: 1.3 }}>
              <StyledMenuSubItem.Text >{title}</StyledMenuSubItem.Text>
              <StyledMenuSubItem.Text >{title2}</StyledMenuSubItem.Text>
            </div>
          )}
          {isNew && (
            <StyledMenuSubItem.RightIcon >
              <NewReleases />
            </StyledMenuSubItem.RightIcon>
          )}
          {notification > 0 && (
            <StyledMenuSubItem.RightIcon >
              <Badge badgeContent={notification} color="primary" />
            </StyledMenuSubItem.RightIcon>
          )}
        </StyledMenuSubItem.Nested>
      )}
    </StyledMenuSubItem.List>
  );
};

export default ListSubItemComponent;
